var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    { staticClass: "popupContainer", on: { click: _vm.onCloseModal } },
    [
      _c(
        "div",
        {
          staticClass: "mobile-premium-modal-container",
          on: {
            click: function ($event) {
              $event.stopPropagation()
            },
            touchstart: _vm.handleTouchStart,
            touchend: _vm.handleTouchEnd,
          },
        },
        [
          _c("div", { staticClass: "mobile-premium-modal-title" }, [
            _vm._v(
              _vm._s(_vm.$t("camstudy.premiumPlusDescriptionModal.title"))
            ),
          ]),
          _c("div", {
            staticClass: "mobile-premium-item-title",
            domProps: { innerHTML: _vm._s(_vm.mobilePremiumItemTitle) },
          }),
          _c("div", {
            staticClass: "mobile-premium-background-image",
            class: _vm.backgroundClass,
          }),
          _vm.currentTab >= 3
            ? _c("div", { staticClass: "absolute premium-background" }, [
                _vm._m(0),
              ])
            : _vm._e(),
          _c("div", {
            staticClass: "mobile-premium-feature-description",
            domProps: { innerHTML: _vm._s(_vm.mobilePremiumDescription) },
          }),
          _c("div", { staticClass: "mobile-premium-select-item-container" }, [
            _c("button", {
              staticClass: "previous-item-button",
              on: { click: _vm.onPreviousButton },
            }),
            _c(
              "div",
              { staticClass: "item-select-list" },
              _vm._l(6, function (item) {
                return _c("div", {
                  key: item,
                  staticClass: "item-select",
                  class: { select: item - 1 === _vm.currentTab },
                  on: { click: () => _vm.onSelectButton(item - 1) },
                })
              }),
              0
            ),
            _c("button", {
              staticClass: "next-item-button",
              on: { click: _vm.onNextButton },
            }),
          ]),
          _c("div", { staticClass: "control-button-container" }, [
            !_vm.isCreateStudy
              ? _c(
                  "button",
                  {
                    staticClass: "control-button",
                    on: { click: _vm.onCloseForever },
                  },
                  [_vm._v("7일간 보지 않기")]
                )
              : _vm._e(),
            _vm.isFreeRoom
              ? _c(
                  "button",
                  {
                    staticClass: "control-button ok free",
                    on: { click: _vm.onMoveShop },
                  },
                  [_vm._v("프리미엄+ 이용권 구매하기")]
                )
              : _c(
                  "button",
                  {
                    staticClass: "control-button ok",
                    on: { click: _vm.onCloseModal },
                  },
                  [_vm._v("확인")]
                ),
          ]),
        ]
      ),
    ]
  )
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("div", { staticClass: "premium-background-text" }, [
      _vm._v("Premium+ "),
      _c("br"),
      _vm._v("Only!"),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }